// extracted by mini-css-extract-plugin
export default {"row":"SelectableOrganizationRow_row__JnS+c","checkbox":"SelectableOrganizationRow_checkbox__bzAYg","nameContainer":"SelectableOrganizationRow_nameContainer__AfYfE"};